<div [ngClass]="{
                'layout-static-sidebar-inactive': staticMenuInactive,
                'layout-mobile-sidebar-active':menuActiveMobile
                }" class="layout-wrapper layout-theme-light layout-static">
  <top-bar></top-bar>
  <div class="layout-sidebar">
    <app-menu></app-menu>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <app-spinner></app-spinner>
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <div *ngIf="menuActiveMobile" class="layout-mask p-component-overlay"></div>
</div>
